import type { ColumnDef} from "@tanstack/react-table";
import { createColumnHelper } from "@tanstack/react-table";

import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import type {
	BenefitsReportTableData,
} from "~/modules/humanResources/components/StaffBenefitsReportView/benefitsReportTableTypes.ts";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";

const columnHelper = createColumnHelper<BenefitsReportTableData>();
export const getBenefitsReportColumnDefs = (benefitKeys: string[]) => {
	const cols = [
		columnHelper.accessor("fullName", {
			header: "Mitarbeiter:in",
			meta: {
				headerTextAlign: "left",
				cellTextAlign: "left",
			},
			cell: (props) => <div className="font-medium">{props.getValue()}</div> ,
		}),
	];

	benefitKeys.forEach((benefitKey) => {
		cols.push(columnHelper.accessor(row=>row[benefitKey], {
			header: benefitKey,
			meta: {
				headerTextAlign: "right",
				cellTextAlign: "right",
				width: "10%",
			},
			cell: (props) => {
				const value = props.getValue() as unknown as number;
				return value ? formatCentsToCurrency(value) : EMPTY_VALUE_PLACEHOLDER;
			},
		}));
	});


	cols.push(columnHelper.accessor("benefitsTotalCents", {
		header: "Gesamt",
		meta: {
			headerTextAlign: "right",
			cellTextAlign: "right",
		},
		cell: (props) => formatCentsToCurrency(props.getValue()),
	}) as ColumnDef<BenefitsReportTableData, string>);

	return cols;
};